import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.admin').factory('PeriodicTask', PeriodicTaskData);

    function PeriodicTaskData() {
        PeriodicTask.prototype = {
            build: build,
            getStatusIcon: getStatusIcon,
            getStatusColor: getStatusColor,
            unlockEnabled: unlockEnabled,
            executeEnabled: executeEnabled
        };

        return PeriodicTask;

        function PeriodicTask(data) {
            this.build(data);
        }

        /////////////////////

        function build(data) {
            if (data) {
                this.id = data.id || null;
                this.name = data.name || null;
                this.executor = data.executor || null;
                this.startDate = data.startDate || null;
                this.endDate = data.endDate || null;
                this.faillureDate = data.faillureDate || null;
                this.lastExecutor = data.lastExecutor || null;
                this.status = data.status || null;
            }
        }

        function getStatusIcon() {
            if (this.status === 'CRITICAL') {
                return 'fa-arrow-circle-down';
            } else if (this.status === 'WARNING') {
                return 'fa-arrow-circle-down';
            } else {
                return 'fa-arrow-circle-up';
            }
        }

        function getStatusColor() {
            if (this.status === 'CRITICAL') {
                return 'red';
            } else if (this.status === 'WARNING') {
                return 'orange';
            } else {
                return 'green';
            }
        }

        function unlockEnabled() {
            // S'il y a un executant et que le status n'est pas OK, alors on peut debloquer la tache.
            return this.executor && this.status !== 'OK';
        }

        function executeEnabled() {
            // S'il n'y a pas d'executant alors on peut executer la tache.
            return !this.executor;
        }
    }
})();
